<template>
  <div class="RGBWWidget lxn-w100 lxn-h100 lxn-overflow-hidden" :class="disabledClass" :style="widgetStyle">
    <div style="height: 15px;" class="lxn-w100">
    </div>
    <div @click="openPalette" class="RGBWWidget-wrapper-d1 lxn-circle lxn-overflow-hidden lxn-margin-auto" :style="shadowStyle">
      <ButtonIcon :size="40" :bgColor="rgbBgColor" icon="turnOff" :iconColor="rgbIconColor" :padding="14" :isRound="true" />
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import iro from '@jaames/iro';
import NODE11 from '@/statics/devices/Node11/header.js'

export default {
  name: 'RGBWWidget',
  props: {
    index: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
      shadowBlur: 15,
    }
  },
  mounted: function () {
  },
  computed: {
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return '';
      }
    },
    node: function () {
      if(this.index != -1){
        return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
      }else{
        return '';
      }
    },
    hub: function () {
      if(this.index == -1){
        return null;
      }
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    output: function () {
      if(this.index == -1){
        return null;
      }else{
        return this.node.outputs[this.widget.settings.outputIndex];
      }
    },
    isHubOffline: function () {
      if(this.index == -1){
        return false;
      }
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    disabledClass: function () {
      if(this.index != -1){
        if(this.isHubOffline){
          return "disabled";
        }else{
          return "";
        }
      }else{
        return "";
      }
    },
    currentColor: function () {
      if(this.index != -1){
        if(this.output.name != 'White'){
          var currentHue = this.$store.getters.getParameterValue(this.node.index, NODE11.HUE.PARAMETER_ID);
          var currentSaturation = this.$store.getters.getParameterValue(this.node.index, NODE11.SATURATION.PARAMETER_ID);
          var currentValue = this.$store.getters.getParameterValue(this.node.index, NODE11.BRIGHTNESS.PARAMETER_ID);
          if( currentHue !== undefined && currentSaturation !== undefined && currentValue !== undefined){
            var currentColor = {
              h: Math.floor((currentHue / 65535) * 360),
              s: Math.floor((currentSaturation / 65535) * 100),
              v: Math.floor((currentValue / 65535) * 100),
            }
          }else{
            currentColor = {
              h: 0,
              s: 0,
              v: 0,
            }
          }
          var currentRGB = iro.Color.hsvToRgb(currentColor);
          if(this.output.type == 'colorPwm' && this.output.name == 'Red'){
            var currentRed = currentRGB.r;
            currentColor = {
              h: 0,
              s: 100,
              v: Math.floor((currentRed / 255) * 100),
            }
          }else if(this.output.type == 'colorPwm' && this.output.name == 'Green'){
            var currentGreen = currentRGB.g;
            currentColor = {
              h: 120,
              s: 100,
              v: Math.floor((currentGreen / 255) * 100),
            }
          }else if(this.output.type == 'colorPwm' && this.output.name == 'Blue'){
            var currentBlue = currentRGB.b;
            currentColor = {
              h: 240,
              s: 100,
              v: Math.floor((currentBlue / 255) * 100),
            }
          }
        }else{
          var currentWhite = this.$store.getters.getParameterValue(this.node.index, NODE11.WHITE.PARAMETER_ID);
          if(currentWhite !== undefined){
            currentColor = {
              h: 0,
              s: 0,
              v: Math.floor((currentWhite / 65535) * 100),
            }
          }else{
            currentColor = {
              h: 0,
              s: 0,
              v: 0,
            }
          }
        }
        return currentColor;
      }else{
        return {
          h: 15,
          s: 100,
          v: 100,
        }
      }
    },
    shadowStyle: function () {
      var currentRGB = iro.Color.hsvToRgb(this.currentColor);
      var shadowSpread = Math.floor(this.currentColor.v / 10);
      var shadowColor = `rgb(${currentRGB.r},${currentRGB.g},${currentRGB.b})`;
      return `box-shadow: 0 0 ${this.shadowBlur}px ${shadowSpread}px ${shadowColor};background-color: ${this.rgbBgColor}`;
    },
    rgbBgColor: function () {
      if(this.currentColor.v !== 0){
        return "#FFFFFF";
      }else{
        return "#132f45";
      }
    },
    rgbIconColor: function () {
      if(this.currentColor.v !== 0){
        return "#1d394f";
      }else{
        return "#87b4c7";
      }
    },
    widgetStyle: function () {
      //was trying to make white light look better on its background, failed for now!
      return '';
      // if(this.index != -1){
      //   if(this.output.name == "White"){
      //     return `background-image: linear-gradient(45deg, rgba(0,0,0,0), rgba(30, 165, 222, 0.8));`;
      //   }else{
      //     return 'background-color: transparent;';
      //   }
      // }else{
      //   return 'background-color: transparent;';
      // }
    }
  },
  methods: {
    openPalette: function () {
      if(this.index != -1){
        this.$router.push('/rgbwWidgetPalette/' + this.index);
      }
    },
  },
}
</script>

<style>
  .RGBWWidget.disabled {
    opacity: 0.5;
  }
  .RGBWWidget-wrapper-d1 {
    width: 40px;
    height: 40px;
    transition: all 300ms linear;
  }
</style>
